import { change, revert } from './changeBodyBG';

export const background = {
  change: change,
  revert: revert
};
